<template>
 <router-view :key="$route.fullPath"></router-view>

  <TwoFactorSetupModal ref="setup2fa" @completed="on2faSetupCompleted" />
  <TwoFactorVerificationModal ref="verify2fa" @completed="on2faVerified" />
  <OtpVerificationModal ref="verifyOtp" @completed="onOtpVerified" />
</template>

<script>
import TwoFactorSetupModal from "@/components/modals/TwoFactorSetupModal.vue";
import TwoFactorVerificationModal from '@/components/modals/TwoFactorVerificationModal.vue'
import OtpVerificationModal from '@/components/modals/OtpVerificationModal.vue'

export default {
  name: 'App',
  components: {
    TwoFactorSetupModal,
    TwoFactorVerificationModal,
    OtpVerificationModal
  },
  data() {
    return {
      pendingVerificationResolver: null, // store resolver for the pending request
      verificationPayload: null,
    }
  },
  created() {
    // Listen for global event to trigger 2FA setup modal
    window.addEventListener('show-2fa-setup', this.handleShow2FASetup)

    // Listen for global event to trigger 2FA verification modal
    window.addEventListener('show-2fa-verification', this.handleShow2FAVerification)

    // Listen for global event to trigger otp verification modal
    window.addEventListener('show-otp-verification', this.handleShowOtpVerification)
  },
  beforeUnmount() {
    window.removeEventListener('show-2fa-setup', this.handleShow2FASetup)
    window.removeEventListener('show-2fa-verification', this.handleShow2FAVerification)
    window.removeEventListener('show-otp-verification', this.handleShowOtpVerification)
  },
  methods: {
    handleShow2FASetup(event) {
      const data = event?.detail || {}
      this.$refs.setup2fa?.openModal(data)
      return new Promise(resolve => {
        this.pendingVerificationResolver = resolve
      })
    },
    handleShow2FAVerification(event) {
      this.verificationPayload = event.detail;
      this.$refs.verify2fa.openModal(event.detail)
      return new Promise((resolve) => {
        this.pendingVerificationResolver = resolve
      })
    },
    on2faSetupCompleted(result) {
      // Called when setup modal is done
      if (this.pendingVerificationResolver) {
        this.pendingVerificationResolver(result)
        this.pendingVerificationResolver = null
      }
    },
    on2faVerified(data) {
      // Called when verification modal is done
      if (this.pendingVerificationResolver) {
        this.pendingVerificationResolver(data)
        this.pendingVerificationResolver = null
      }
    },

    handleShowOtpVerification(event) {
      this.verificationPayload = event.detail
      this.$refs.verifyOtp.openModal(event.detail)
      return new Promise((resolve) => {
        this.pendingVerificationResolver = resolve
      })
    },

    onOtpVerified(data) {
      if (this.pendingVerificationResolver) {
        this.pendingVerificationResolver(data)
        this.pendingVerificationResolver = null
      }
    },
  },
}
</script>
